$(function () {

    /**
     * Nav : if scroll top show nav else hide nav
     */
    var didScroll = false;
    var lastScrollTop = $(this).scrollTop();
    var delta = 5;
    var navbarHeight = $(".menu").outerHeight();

    $(window).scroll(function () {
        
        didScroll = true;

    });

    function hasScrolled() {

        if (!$(".menu").hasClass('menu--opened')) {

            var st = $(this).scrollTop();

            // Make sure they scroll more than delta
            if(Math.abs(lastScrollTop - st) <= delta)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > navbarHeight) {
                // Scroll Down
                $(".menu:not('menu--opened')").addClass("nav-up");
                $(".sticky").addClass("nav-up");
            } else {
                // Scroll Up
                if(st + $(window).height() < $(document).height()) {
                    $(".menu:not('menu--opened')").removeClass("nav-up");
                    $(".sticky").removeClass("nav-up");
                }
            }

            lastScrollTop = st;

        }

    }

    setInterval(function () {

        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }

    }, 250);



    /**
     * Nav mobile
     */
    $('.menu-m__nav__item__link--submenu').click(function(e) {

        e.preventDefault();

        $('.menu-m__nav').addClass('hide-mobile');
        $('.sub-menu-m').addClass('show-mobile');

        var href = $(this).attr('href');
        $(href).show().addClass('active');

    });

    $('#menu-back').click(function(e) {

        e.preventDefault();

        $('.menu-m__nav').removeClass('hide-mobile');
        $('.sub-menu-m').removeClass('show-mobile');

        $('.sub-menu-m__wrapper').hide().removeClass('active');

    });



    /**
     * Burger nav mobile
     */
    var burger = document.querySelector('.burger'),
        header = document.querySelector('.menu'),
        subMenu = document.querySelector('.sub-menu-m');

        if(burger !== null) {
            burger.onclick = function() {
                header.classList.toggle('menu--opened'); 
        
                    if (subMenu.classList.contains('show-mobile')) {
        
                        $('.sub-menu-m').removeClass('show-mobile');
                        $('.menu-m__nav').removeClass('hide-mobile');
                        $('.sub-menu-m__wrapper').hide().removeClass('active');
                    } 
            };
        }
      
  
 

    /**
     * Form
     */
    $('.form__field__input, .form__field__textarea').change(function(){
        if($(this).val()) {
            $(this).siblings('.form__field__label').addClass('has-value');
        } else {
            $(this).siblings('.form__field__label').removeClass('has-value');
        }
    });

    $('.form__field__radio').change(function(){
        if($(this).val()) {
            $(this).parents('.form__group__body').siblings('.form__group__head').addClass('has-value');
        } else {
            $(this).parents('.form__group__body').siblings('.form__group__head').removeClass('has-value');
        }
    });

    $('.form__field__select').change(function(){
        if($(this).val()) {
            $(this).parents('.form__list__body').siblings('.form__list__head').addClass('has-value');
        } else {
            $(this).parents('.form__list__body').siblings('.form__list__head').removeClass('has-value');
        }
    });



    /**
     * Smooth scroll anchor
     */
    $('.nav-anchor__link').click(function(e) {
        e.preventDefault();

        $("html, body").animate({
            scrollTop: $( $.attr(this, 'href') ).offset().top
        }, "slow");
    });



    /**
     * Form newsletter
     */
    $('#form-newsletter').find('.form-inline__field__input').bind("change paste keydown", function() {
        $('#form-newsletter').removeClass('form-inline--success');
        $('#form-newsletter').removeClass('form-inline--error');
        $('#form-newsletter').find('.fa-times').addClass('fa-chevron-right').removeClass('fa-times');
        $('#form-newsletter').find('.fa-check').addClass('fa-chevron-right').removeClass('fa-check');
    });

    $('#form-newsletter').submit(function (event) {
        event.preventDefault();

        $('#notification-newsletter').html('');
        $('#notification-newsletter').removeClass('alerts--error');
        $('#notification-newsletter').removeClass('alerts--success');

        $.ajax({
            url: $(this).attr('action'),
            type: "POST",
            data: new FormData(this),
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function (response) {
                if (response.status === "success") {
                    $('#notification-newsletter').html('Merci pour votre inscription à notre newsletter.').addClass('alerts--success');
                    $('#form-newsletter').find('.fa-chevron-right').addClass('fa-check').removeClass('fa-chevron-right');
                    $('#form-newsletter').addClass('form-inline--success');
                } else if (response.status === "error") {
                    $('#form-newsletter').find('.fa-chevron-right').addClass('fa-times').removeClass('fa-chevron-right');
                    $('#form-newsletter').addClass('form-inline--error');

                    if (response.reason === "already") {
                        $('#notification-newsletter').html('Merci pour votre inscription mais vous êtes déjà inscrit à notre newsletter.').addClass('alerts--error');
                    } else {
                        $('#notification-newsletter').html("Une erreur s'est produite. Veuillez-nous en excuser.").addClass('alerts--error');
                    }
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr);
                console.log(ajaxOptions);
                console.log(thrownError);
            }
        });
    });


    /**
     *  Add class in <br> on find-br class
     */
    $('.find-br').find('br').addClass('is-hidden-mobile');


 
    /**
     * Accordion
     *
     * Talent, Recruiter & Taxonomy help + Footer
     */
    var submenu = $(".accordion__body").hide();

    $(".accordion__header").click(function () {

        if (!$(this).hasClass("close")) {
            $(".accordion__header").removeClass("close");
            $(".accordion__header").find(".fas").removeClass("active");
            submenu.slideUp();
            $(this).addClass("close");
            $(this).find(".fas").addClass("active");
            $(this).next(".accordion__body").slideDown();
        } else {
            $(this).next().slideUp();
            $(this).removeClass("close");
            $(this).find(".fas").removeClass("active");
        }

    });

});
    
